<template>
  <ListView
    title="Tables"
    @reload="reload"
    @navDetails="actionDetails"
    :data="data"
    :page.sync="page"
    :header="header"
    :enableCreate="false"
  >
    <template v-slot:searchBox>
      <!-- Disable search by providing empty slot -->
    </template>
    <template v-slot:item.time="{ item }">
      {{ item.time.startDate | moment }} - {{ item.time.endDate | moment }}
    </template>
    <template v-slot:item.owner="{ item }">
      {{ get(item, 'owner.name', '-') }}
    </template>
  </ListView>
</template>

<script>
import { RESTFUL } from '@/data/constants';
import listViewPageMixin from '@/services/listViewPageMixin';
import { get } from 'lodash';

export default {
  name: 'IdentityTablesList',
  props: {
    profileId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      header: [
        { text: 'Owner', value: 'owner' },
        { text: 'Time', value: 'time' },
        { text: 'Location', value: 'location' },
        { text: 'District', value: 'locationDistrict' },
        { text: 'Status', value: 'status' },
      ],
      populate: 'owner',
    };
  },
  mixins: [listViewPageMixin],
  computed: {
    restfulURL() {
      return RESTFUL.tables.list;
    },
    filter() {
      return {
        owner: this.profileId,
      };
    },
  },
  methods: {
    get,
    actionDetails(item) {
      if (item && item._id) {
        this.$router.push({ name: 'table', params: { id: item._id } });
      }
    },
  },
};
</script>
